import { setTag } from "@sentry/react";
import { ReplayTag, TagValue } from "../tags/tag-types";

export function setMonitoringTag(tagName: ReplayTag, value: TagValue) {
    setTag(tagName, value);
}
